import { useCallback } from 'react'

import type { one_to_one } from '@fireworkhq/proto-contract'
import { useMessageChannelContext } from '@liveHelper/context/MessageChannelContext'
import {
  actionsSelector,
  nextMessagesCursorSelector,
  useStoreApi,
} from '@liveHelper/models/store'

import { logError } from '@core/logging'

/**
 * Callback for loading of more messages inside LiveHelper
 */
export const useLoadMoreMessages = () => {
  const storeApi = useStoreApi()
  const messageChannel = useMessageChannelContext()
  return useCallback(() => {
    const state = storeApi.getState()
    const nextCursor = nextMessagesCursorSelector(state)
    if (!nextCursor) {
      return
    }
    messageChannel
      ?.push('load_messages', { cursor: nextCursor, page_size: 20 })
      ?.receive(
        'ok',
        (payload: one_to_one.message.LoadMessagesResponsePayload) => {
          const actions = actionsSelector(state)
          actions.addChatMessages(
            payload.messages ?? [],
            'visitor',
            payload?.next_cursor ?? null,
          )
        },
      )
      ?.receive('error', (payload) => {
        logError(new Error('Load more messages failed'), {
          captureContext: {
            extra: {
              payload: JSON.stringify(payload),
            },
          },
        })
      })
  }, [storeApi, messageChannel])
}
